var React = require('react');

function RightCircleArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.896 1l5.377 5.378-5.377 5.377M12.772 6.456H0","fill":"none","stroke":"#2D294F","strokeWidth":"1.5"}));
}

RightCircleArrow.defaultProps = {"viewBox":"0 0 15 13"};

module.exports = RightCircleArrow;

RightCircleArrow.default = RightCircleArrow;
